import Button from './button';

const NewsCta = () => {
  return (
    <div className="mx-auto mt-10 max-w-prose">
      <h2 className="mb-2">Support the ’bot!</h2>
      <p className="mb-4">
        Upgrade to premium for AI-writing, daily front pages, a custom keyword,
        and tons of features for members only. Or buy one-time coins to upgrade
        your deliveries to fax or postal mail, or to promote campaigns you
        care&nbsp;about!
      </p>
      <Button theme="animated" href={`/premium`} className="mr-4">
        Upgrade to Premium
      </Button>
      <Button theme="light" href={`/premium/coins`}>
        Buy Coins
      </Button>
    </div>
  );
};

export default NewsCta;
